// * for routing service stuff
const LINE_UI_STYLE = {
	lineWidth: 6,
	strokeColor: "rgba(0, 128, 255, 0.7)",
} satisfies H.map.SpatialStyle.Options;

const routingLib = { LINE_UI_STYLE };

export default routingLib;
